import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";

const services = [
  {
    title: "Airport Transfers",
    description: "Door-to-door service from PUJ, SDQ, STI, and all Dominican airports to your hotel, resort, or Airbnb.",
    image: "https://images.unsplash.com/photo-1544620347-c4fd4a3d5957?w=600&h=400&fit=crop&fm=webp&q=80",
  },
  {
    title: "Hotel to Hotel",
    description: "Moving between resorts? We calculate the best route and offer fixed pricing for all inter-hotel transfers.",
    image: "https://images.unsplash.com/photo-1566073771259-6a8506099945?w=600&h=400&fit=crop&fm=webp&q=80",
  },
  {
    title: "Group Transfers",
    description: "Traveling with a large group? Our vans and minibuses accommodate up to 15+ passengers comfortably.",
    image: "https://images.unsplash.com/photo-1570125909232-eb263c188f7e?w=600&h=400&fit=crop&fm=webp&q=80",
  },
];

const ServicesSection = () => {
  return (
    <section id="services" className="py-20 md:py-28 bg-navy">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <p className="text-primary font-sans font-semibold tracking-[0.2em] uppercase text-sm mb-3">
            Our Services
          </p>
          <h2 className="font-display text-3xl md:text-5xl font-bold text-hero-foreground">
            Premium Transfer <span className="text-primary">Solutions</span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <motion.div
              key={service.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.15 }}
              className="group relative overflow-hidden rounded-2xl"
            >
              <img
                src={service.image}
                alt={service.title}
                className="w-full h-80 object-cover group-hover:scale-105 transition-transform duration-500"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-hero-bg/90 via-hero-bg/30 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-6">
                <h3 className="font-display text-2xl font-bold text-hero-foreground mb-2">
                  {service.title}
                </h3>
                <p className="text-hero-foreground/70 font-sans text-sm leading-relaxed mb-4">
                  {service.description}
                </p>
                <a
                  href="#"
                  className="inline-flex items-center gap-2 text-primary font-sans font-semibold text-sm group-hover:gap-3 transition-all"
                >
                  Learn More <ArrowRight className="w-4 h-4" />
                </a>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
